module.exports = __webpack_public_path__ + "img/anzhuangzhiru.8b25e662.png";